import axios from "axios";
export const instance = axios.create();
instance.defaults.baseURL = "https://mm-darkmode.azurewebsites.net/";
